import { useContext, useEffect, useRef, useState } from 'react';
import '../css/selectWeekDashboardComponent.css'
import { useTranslation } from 'react-i18next';
import CalendarIcon from '../icons/calendar'
import useSWR from 'swr';
import { hrGetWeekStatsEndpoint } from '../hr_endpoints';
import { ToastDataContext } from '../context/ToastContextProvider';

export default function SelectWeekDashboardComponent({ onSelectWeek }) {

    const { t } = useTranslation();

    const [isOpen, setIsOpen] = useState(false);
    const [currentWeek, setCurrentWeek] = useState(0);
    const [selectedWeek, setSelectedWeek] = useState('');
    const triggerRef = useRef(null);
    const dropdownRef = useRef(null);
    const toastContext = useContext(ToastDataContext);

    const { data, error } = useSWR([hrGetWeekStatsEndpoint])

    useEffect(() => {
        if (error) {
            toastContext.error(error.message)
        }
    }, [error])

    useEffect(() => {
        if (data) {
            setSelectedWeek(data[0])
        }
    }, [data])

    useEffect(() => {
        if (selectedWeek) {
            onSelectWeek(selectedWeek)
        }
    }, [selectedWeek])

    useEffect(() => {
        document.addEventListener('click', handleOutsideClick);
        document.addEventListener('keydown', handleEscape);

        return () => {
            document.removeEventListener('click', handleOutsideClick);
            document.removeEventListener('keydown', handleEscape);
        };
    }, []);

    const selectWeek = (week, index) => {
        setSelectedWeek(week);
        setIsOpen(false);

        setCurrentWeek(index);
    };

    const toggleDropdown = () => setIsOpen(!isOpen);

    const handleOutsideClick = (e) => {
        if (
            dropdownRef.current &&
            !dropdownRef.current.contains(e.target) &&
            !triggerRef.current.contains(e.target)
        ) {
            setIsOpen(false);
        }
    };

    const handleEscape = (e) => {
        if (e.key === 'Escape') {
            setIsOpen(false);
        }
    };

    return (
        <div className="relative week-selector">
            <button
                ref={triggerRef}
                onClick={toggleDropdown}
                className={`week-selector-trigger flex items-center space-x-2 px-4 py-2 rounded-lg text-sm font-medium text-gray-700 ${isOpen ? 'active' : ''
                    }`}
            >
                <CalendarIcon className="w-4 h-4" />
                <span>{`${t('dashboard.week')} ${selectedWeek}`}</span>
                <i
                    className={`fas fa-chevron-down text-gray-400 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''
                        }`}
                ></i>
            </button>

            {isOpen && (
                <div
                    ref={dropdownRef}
                    className="week-dropdown absolute top-full left-0 mt-2 bg-white rounded-lg shadow-lg border border-gray-200 py-2 z-50"
                >
                    <div className="px-3 py-2 text-xs font-semibold text-gray-500 uppercase tracking-wide border-b border-gray-100">
                        {t('dashboard.selectWeek')}
                    </div>
                    <div className="max-h-64 overflow-y-auto">
                        {data?.map((week, index) => (
                            <div
                                key={index}
                                onClick={() => selectWeek(week, index)}
                                className={`week-option px-4 py-3 text-sm cursor-pointer transition-colors duration-150 ${currentWeek === index
                                    ? 'bg-blue-50 text-blue-700 font-medium'
                                    : 'text-gray-700'
                                    }`}
                            >
                                {`${t('dashboard.week')} ${week}`}
                                {currentWeek === index && (
                                    <span className="ml-2 px-2 py-1 text-xs bg-blue-100 text-blue-700 rounded-full">
                                        {t('dashboard.currentWeek')}
                                    </span>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
}